import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '@plurall/elo-beta'
import { ADD_RESPONSIBLE } from 'graphql/mutations'
import { graphqlClient } from 'utils'

const ResendEmailResponsible = ({ closeAlert, selectResponsible, idPerson }) => {
  const sendEmail = async () => {
    try {
      await graphqlClient().mutate({
        mutation: ADD_RESPONSIBLE,
        errorPolicy: 'all',
        variables: {
          dependentId: +idPerson,
          email: selectResponsible.email,
        },
      })
    } catch (e) {
      window.PLURALL_ELO_TOAST_CONTAINER.addToast({
        variant: 'negative',
        text: 'Erro ao enviar e-mail',
      })
    }

    window.PLURALL_ELO_TOAST_CONTAINER.addToast({
      variant: 'positive',
      text: 'E-mail enviado com sucesso.',
    })
    closeAlert()
  }
  return (
    <Alert
      variant={'informative'}
      title={'Reenviar e-mail'}
      primaryButtonText={'Confirmar'}
      onSecondaryClick={closeAlert}
      secondaryButtonText={'Cancelar'}
      onPrimaryClick={sendEmail}
    >
      Você deseja reenviar o e-mail para o responsável?
    </Alert>
  )
}

ResendEmailResponsible.propTypes = {
  idPerson: PropTypes.string.isRequired,
  selectResponsible: PropTypes.object,
  closeAlert: PropTypes.func,
}

export default ResendEmailResponsible
